import { Navigate, createBrowserRouter } from 'react-router-dom'
import { Layout } from './layout'
import ProtectedRoute from '../../components/shared/protected-route'
import { DevicesRoute } from './devices'
import { BusinessesRoute } from './businesses'
import { SingleDeviceRoute } from './single-device'
import { SingleDeviceLiveRoute } from './single-device/live'
import { SingleDeviceLocationRoute } from './single-device/location'
import { SingleDeviceHistoryRoute } from './single-device/history'
import { SingleDeviceAttributeRoute } from './single-device/single-attribute'
// import { RegisterDeviceRoute } from './register'
// import { SingleDeviceConfigurationRoute } from './single-device/configuration'
import { SingleDeviceErrorsRoute } from './single-device/errors'
import { LoginRoute } from './auth/login'
import { LogoutRoute } from './auth/logout'
import { ForgotPasswordRoute } from './auth/forgot-password'
import { ResetPasswordRoute } from './auth/reset-password'
import { OAuthConsentRoute } from './auth/oauth-consent'
import { ErrorDetailRoute } from './single-device/errors/details'
import { UpdatePackageUploaderRoute } from './update'
import { ModelsRoute } from './models'
import { UsersRoute } from './users'
import UserDetailsPage from './single-user'
import { LocationsRoute } from './locations'
import LogsRoute from './logs'
import { ProfileRoute } from './profile'
import { RegisterBusinessRoute } from './businesses/register'
import { RegisterModelRoute } from './models/register'
import { SingleModelRoute } from './models/single-model'
import { ModelAttributesRoute } from './models/single-model/attributes'
import { ModelConfigTemplatesRoute } from './models/single-model/config-templates'
import { ModelDashboardsRoute } from './models/single-model/dashboards'
import { DashboardConfiguratorRoute } from './models/single-model/dashboards/configurator'
import { ModelRulesRoute } from './models/single-model/rules'
import { ErrorDefinitionsRoute } from './error-definitions'
import { DeviceSettingsRoute } from './single-device/settings'
import { DeviceServicesRoute } from './single-device/services'
import { DashboardRoute } from './dashboard'
import { SettingsRoute } from './settings'

export const createRouter = () => {
    const router = createBrowserRouter([
        {
            children: [
                {
                    path: '/login',
                    element: <LoginRoute />,
                },
                {
                    path: '/logout',
                    element: <LogoutRoute />,
                },
                {
                    path: '/forgot-password',
                    element: <ForgotPasswordRoute />,
                },
                {
                    path: '/reset-password',
                    element: <ResetPasswordRoute />,
                },
                {
                    path: '/oauth/consent',
                    element: <OAuthConsentRoute />,
                },
            ],
        },
        {
            element: <Layout />,
            children: [
                {
                    path: '/dashboard',
                    element: (
                        <ProtectedRoute
                            permissions={{ device: ['read'] }}
                            component={DashboardRoute}
                        />
                    ),
                },
                {
                    path: '/businesses/register',
                    element: (
                        <ProtectedRoute
                            permissions={{ business: ['create'] }}
                            component={RegisterBusinessRoute}
                        />
                    ),
                },
                {
                    path: '/businesses',
                    element: (
                        <ProtectedRoute
                            permissions={{ business: ['read'] }}
                            component={BusinessesRoute}
                        />
                    ),
                },
                {
                    path: '/models/register',
                    element: (
                        <ProtectedRoute
                            permissions={{ model: ['configure'] }}
                            component={RegisterModelRoute}
                        />
                    ),
                },
                {
                    path: '/models/:id/attributes',
                    element: (
                        <ProtectedRoute
                            permissions={{ model: ['read'] }}
                            component={ModelAttributesRoute}
                        />
                    ),
                },
                {
                    path: '/models/:id/config-templates',
                    element: (
                        <ProtectedRoute
                            permissions={{ model: ['read'] }}
                            component={ModelConfigTemplatesRoute}
                        />
                    ),
                },
                {
                    path: '/models/:id/errors',
                    element: (
                        <ProtectedRoute
                            permissions={{ model: ['read'] }}
                            component={ErrorDefinitionsRoute}
                        />
                    ),
                },
                {
                    path: '/models/:id/dashboards',
                    element: (
                        <ProtectedRoute
                            permissions={{ model: ['configure'] }}
                            component={ModelDashboardsRoute}
                        />
                    ),
                },
                {
                    path: '/models/:id/dashboards/:dashboardId',
                    element: (
                        <ProtectedRoute
                            permissions={{ model: ['configure'] }}
                            component={DashboardConfiguratorRoute}
                        />
                    ),
                },
                {
                    path: '/models/:id/rules',
                    element: (
                        <ProtectedRoute
                            permissions={{ model: ['configure'] }}
                            component={ModelRulesRoute}
                        />
                    ),
                },
                {
                    path: '/models/:id',
                    element: (
                        <ProtectedRoute
                            permissions={{ model: ['read'] }}
                            component={SingleModelRoute}
                        />
                    ),
                },
                {
                    path: '/models',
                    element: (
                        <ProtectedRoute
                            permissions={{ model: ['read'] }}
                            component={ModelsRoute}
                        />
                    ),
                },
                // {
                //     path: '/devices/register',
                //     element: (
                //         <ProtectedRoute
                //             permissions={{ device: ['create'] }}
                //             component={RegisterDeviceRoute}
                //         />
                //     ),
                // },

                {
                    path: '/devices/:id',
                    element: (
                        <ProtectedRoute
                            permissions={{ device: ['read'] }}
                            component={SingleDeviceRoute}
                        />
                    ),
                },
                {
                    path: '/devices/:id/settings',
                    element: (
                        <ProtectedRoute
                            permissions={{ device: ['read'] }}
                            component={DeviceSettingsRoute}
                        />
                    ),
                },
                {
                    path: '/devices/:id/services',
                    element: (
                        <ProtectedRoute
                            permissions={{ device: ['read'] }}
                            component={DeviceServicesRoute}
                        />
                    ),
                },
                {
                    path: '/devices/:id/live',
                    element: (
                        <ProtectedRoute
                            permissions={{ device: ['read'] }}
                            component={SingleDeviceLiveRoute}
                        />
                    ),
                },
                {
                    path: '/devices/:deviceId/attributes/:attributeId',
                    element: (
                        <ProtectedRoute
                            permissions={{ device: ['read'] }}
                            component={SingleDeviceAttributeRoute}
                        />
                    ),
                },
                {
                    path: '/devices/:id/location',
                    element: (
                        <ProtectedRoute
                            permissions={{ device: ['read'] }}
                            component={SingleDeviceLocationRoute}
                        />
                    ),
                },
                {
                    path: '/devices/:id/history',
                    element: (
                        <ProtectedRoute
                            permissions={{ device: ['read'] }}
                            component={SingleDeviceHistoryRoute}
                        />
                    ),
                },
                {
                    path: '/devices/:id/errors',
                    element: (
                        <ProtectedRoute
                            permissions={{ device: ['read'] }}
                            component={SingleDeviceErrorsRoute}
                        />
                    ),
                },
                {
                    path: '/devices/:id/errors/:errorId',
                    element: (
                        <ProtectedRoute
                            permissions={{ device: ['read'] }}
                            component={ErrorDetailRoute}
                        />
                    ),
                },
                // {
                //     path: "/devices/:id/config",
                //     element: <ProtectedRoute permissions={{ device: ["configure"] }} component={SingleDeviceConfigurationRoute} />,
                // },
                {
                    path: '/devices',
                    element: (
                        <ProtectedRoute
                            permissions={{ device: ['read'] }}
                            component={DevicesRoute}
                        />
                    ),
                },
                {
                    path: '/locations',
                    element: (
                        <ProtectedRoute
                            permissions={{ device: ['read'] }}
                            component={LocationsRoute}
                        />
                    ),
                },
                {
                    path: '/updates',
                    element: (
                        <ProtectedRoute
                            permissions={{ update: ['create'] }}
                            component={UpdatePackageUploaderRoute}
                        />
                    ),
                },
                {
                    path: '/logs',
                    element: (
                        <ProtectedRoute
                            permissions={{ log: ['read'] }}
                            component={LogsRoute}
                        />
                    ),
                },
                {
                    path: '/users',
                    element: (
                        <ProtectedRoute
                            permissions={{ user: ['list'] }}
                            component={UsersRoute}
                        />
                    ),
                },
                {
                    path: '/users/:id',
                    element: (
                        <ProtectedRoute
                            permissions={{ user: ['update'] }}
                            component={UserDetailsPage}
                        />
                    ),
                },
                {
                    path: '/settings',
                    element: (
                        <ProtectedRoute
                            permissions={{ device: ['configure'] }}
                            component={SettingsRoute}
                        />
                    ),
                },
                {
                    path: '/profile',
                    element: <ProfileRoute />,
                },
                {
                    path: '/*',
                    element: <Navigate to="/dashboard" />,
                },
            ],
        },
    ])

    return router
}
